import { CreateAppointmentDtoSchema } from '@myapp/contract';
import { create } from 'zustand';
import { z } from 'zod';

const createAppointmentShape = CreateAppointmentDtoSchema.shape;

export const AppointmentDraftSchema = CreateAppointmentDtoSchema.omit({
  /* tradeCode: true, */
  plannedStart: true,
}).extend({
  tradeCode: createAppointmentShape.tradeCode.optional(),
  plannedStart: createAppointmentShape.plannedStart.optional(),
});

export type AppointmentDraft = z.infer<typeof AppointmentDraftSchema>;

interface AppointmentDraftState {
  draft: AppointmentDraft | null;
  setDraft: (draft: AppointmentDraft) => void;
  patchDraft: (patch: Partial<AppointmentDraft>) => void;
  clearDraft: () => void;
}

export const useAppointmentDraftStore = create<AppointmentDraftState>((set, get) => ({
  draft: {
    workOrderId: '',
    assignedTechnicianId: 0,
    plannedStart: '',
    tradeCode: 1,
    plannedDepartureDuration: 15,
    plannedTravelDuration: 15,
    plannedWorkDuration: 60,
    attachments: null,
  },

  setDraft: (draft) => {
    set({ draft: AppointmentDraftSchema.parse(draft) });
  },

  patchDraft: (patch) => {
    const currentDraft = get().draft;
    if (!currentDraft) return;

    set({ draft: AppointmentDraftSchema.parse({ ...currentDraft, ...patch }) });
  },

  clearDraft: () => {
    set({ draft: null });
  },
}));
